<template>
  <div class="energy-air">
    <p>最适温度：26</p>
    <div class="air-box">
      <div>
        <el-table :data="tableData" :summary-method="getSummaries" show-summary style="width: 100%">
          <el-table-column
            v-for="head in tableHead"
            :key="head.prop"
            align="center"
            :prop="head.prop"
            :label="head.name"
            :width="head.width"
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div>最适温度耗时</div>
        <reder-charts
          :height="'375px'"
          :width="'100%'"
          :options="airOptions"
        ></reder-charts>
      </div>
    </div>
  </div>
</template>

<script>
import RederCharts from '@/components/RederCharts'
export default {
  components: {
    RederCharts
  },
  data() {
    return {
      tableHead: [
        {
          name: '时间',
          prop: 'time'
        },
        {
          name: '最适温度耗时（分钟）',
          prop: 'minute'
        },
        {
          name: '室外温度(°C)',
          prop: 'pm'
        },
        {
          name: '出水温度(°C)',
          prop: 'num'
        },
      ],
      tableData: [
        {
          time: '2020',
          minute: 20,
          pm: 26,
          num: 2
        },
        {
          time: '2021',
          minute: 20,
          pm: 26,
          num: 2
        },
      ],
      airOptions: null
    }
  },
  created() {
    this.airOptions = this.getOption()
  },
  methods: {
    getOption() {
      return {
        title: {
          text: '最适温度耗时(分钟)',
          top: 20,
          left: 40,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: (param) => {
            param = param[0];
            let arr = []
            this.tableHead.map(v => {
              arr.push(v.name + '：' + this.tableData[param.dataIndex][v.prop] + '<br/>')
            })
            return arr.join('');
          }
        },
        legend: {
          show: true,
          top: 20,
          left: 180,
          icon: 'rect',
          itemWidth: 20,
          itemHeight: 8,
          textStyle: {
            color: '#fff'
          }

        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#9fa3a8'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: this.tableData.map(v => v.time)
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#9fa3a8'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [{
          name: '最适温度耗时',
          color: '#ff8902',
          data: this.tableData.map(v => v.minute),
          type: 'line',
          lineStyle: {
            width: 4
          }
        }]
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '平均';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = parseInt(sums[index] / data.length)
        } else {
          sums[index] = '';
        }
      });

      return sums;
    }
  }
}
</script>

<style lang="scss" scoped>
.energy-air {
  height: calc(100% - 70px);
  margin: 25px;
  background-color: #fff;
  padding: 5px 25px;
  p {
    border-bottom: 2px solid #02a7f0;
    padding-bottom: 8px;
  }
}
.air-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
  &:last-child {
    padding-top: 10px;
    div {
      &:first-child {
        text-align: center;
        font-weight: 700;
      }
    }
  }
}
/deep/ .el-table th {
  background-color: #f5f7fa;
}
</style>